import type { TreeNodeType } from '@/shared/lib/tree'
import type { FieldViewProps, ValueState } from '../../types'
import type TreeSelectController from './Controller'

import { useMemo } from 'react'

import { Spinner } from '@/shared/components/ui/spinner'

import PopoverFooter from '../../components/PopoverFooter'
import TreeSelect from '../../components/TreeSelect'

type Props = FieldViewProps<TreeSelectController> & {
	localValue: ValueState<string[]>
}
export default function TreeSelectView({
	field,
	localValue,
	isDirty,
	isRemovable,
	onRemove,
	onChange,
	onApply,
	closePopup,
}: Props) {
	const { operation } = localValue
	const { useSelectOptions } = field
	const selectOptions = useSelectOptions()
	const options: TreeNodeType[] = useMemo(
		() => (selectOptions.data || []) as TreeNodeType[],
		[selectOptions.data]
	)
	const value = useMemo(() => localValue?.value || [], [localValue])

	const handleChange = (value: string[]) => onChange({ operation, value })
	const handleApply = () => {
		onApply?.()
		closePopup()
	}

	return (
		<div className='min-w-[320px]'>
			{selectOptions.isLoading ? (
				<div className='flex h-20 items-center justify-center'>
					<Spinner />
				</div>
			) : (
				<TreeSelect
					placeholder={field.placeholder}
					tree={options}
					value={value}
					onChange={handleChange}
				/>
			)}
			<PopoverFooter
				isDisabledApply={!isDirty}
				onRemove={isRemovable ? onRemove : undefined}
				onApply={handleApply}
			/>
		</div>
	)
}
